<template>
  <b-modal v-model="show" title="Upgrade to Premium" centered hide-footer>
    <b-card
      no-body
      v-cloak
      class="rounded-0 border-0 mx-0"
      @drop.prevent=""
      @dragover.prevent
    >
      <div class="mb-4 font-weight-bold">
        1 month free, then {{ isTradieUser ? '$1.99' : '$9.99' }}/month
      </div>
      <div class="mb-4 text-muted">
        Subscribe to Tradie Pass Premium to unlock these features
      </div>
      <div>
        <ul class="subscription-details">
          <li>
            <div class="item">
              Unlimited sharing for profiles and documents to business admins
            </div>
          </li>
          <li>
            <div class="item">
              Quick and secured access through Biometric Authentication for
              mobile app
            </div>
          </li>
          <li>
            <div class="item">
              Quick document organisation - pinning documents for top view
            </div>
          </li>
        </ul>
      </div>

      <div class="my-4 mx-0">
        <b-button
          class="px-5 btn-outlined bg-white text-dark"
          variant="outline-secondary"
          :style="'height: 56px;'"
          @click="closeModal"
        >
          No, thanks
        </b-button>
        <b-button
          class="h-auto float-right py-3 px-5"
          variant="primary"
          :to="{ name: 'premium.subscription' }"
        >
          Continue
        </b-button>
      </div>
    </b-card>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: this.value,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },
  },

  methods: {
    closeModal() {
      this.show = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-content {
  padding: 25px !important;
}
.btn.btn-outlined {
  padding: 4px 32px;
}
.btn {
  height: 36px;
}
.subscription-details {
  li:before {
    content: url('~@/assets/icons/subscription-filled-check.svg');
    margin-left: -32px;
    transform: scale(1.6);
  }

  li {
    list-style-type: none;
    margin-bottom: 16px;
  }
}
.item {
  margin-top: -40px;
  margin-left: 10px;
}
</style>
